import type { MessageResearch } from './MessageResearch';
import type { ChatMessageResearchStore } from './types';

export const getMessageResearchById = (
	state: ChatMessageResearchStore,
	messageId: string,
): MessageResearch | undefined => state[messageId];
